
import { namespace } from 'vuex-class';
import { Vue, Component, ProvideReactive } from 'vue-property-decorator';

import {
	GetAgeCertificationsDocument,
	GetAgeCertificationsQuery,
} from '@/pages/graphql/queries/GetAgeCertifications.query';
import { AgeCertifications, AgeCertificationsConstant } from '@/stores/constant.store';

const Language = namespace('language');

@Component({
	name: 'InjectConstants',
	apollo: {
		ageCertificationsConstant: {
			query: GetAgeCertificationsDocument,
			variables() {
				return { country: this.country };
			},
			update({ organizations, movies, shows }: GetAgeCertificationsQuery): AgeCertifications {
				return {
					shows,
					movies,
					hasCertifications: movies.length > 0 || shows.length > 0,
					organizations: [
						...new Set(organizations.map(({ organization }) => organization).filter(name => name !== '')),
					],
				};
			},
		},
	},
})
export default class InjectConstants extends Vue {
	@Language.Getter country: string;

	/* AGE CERTIFICATIONS */
	@ProvideReactive(AgeCertificationsConstant)
	ageCertificationsConstant: AgeCertifications = {
		shows: [],
		movies: [],
		organizations: [],
		hasCertifications: false,
	};
	/*********************/

	render() {
		if (this.$scopedSlots.default) {
			return this.$scopedSlots.default({});
		}
		return this.$slots[0];
	}
}
